import { Filter, ConditionOperatorsEnum } from 'utils/filters';

export const filterOptions: Filter[] = [
  {
    field: 'display_name',
    label: 'DYNAMIC_FILTER.COMPANY_NAME_KEY',
    multiple: true,
    defaultOperator: ConditionOperatorsEnum.ICONTAINS,
  },
  {
    field: 'company_status',
    label: 'DYNAMIC_FILTER.COMPANY_STATUS_KEY',
    isSelect: true,
    selectOptions: [
      { value: 'active', label: 'DYNAMIC_FILTER.ACTIVE_KEY' },
      { value: 'inactive', label: 'DYNAMIC_FILTER.INACTIVE_KEY' },
    ],
  },
  {
    field: 'company_type',
    label: 'DYNAMIC_FILTER.COMPANY_TYPE_KEY',
    isSelect: true,
    selectOptions: [
      { value: 'client', label: 'DYNAMIC_FILTER.CLIENT_KEY' },
      { value: 'partner', label: 'DYNAMIC_FILTER.PARTNER_KEY' },
    ],
  },
  {
    field: 'responsible_email',
    label: 'DYNAMIC_FILTER.RESPONSIBLE_EMAIL_KEY',
    defaultOperator: ConditionOperatorsEnum.ICONTAINS,
  },
  {
    field: 'responsible_name',
    label: 'DYNAMIC_FILTER.RESPONSIBLE_NAME_KEY',
    defaultOperator: ConditionOperatorsEnum.ICONTAINS,
  },
  {
    field: 'responsible_phone',
    label: 'DYNAMIC_FILTER.RESPONSIBLE_PHONE_KEY',
    defaultOperator: ConditionOperatorsEnum.ICONTAINS,
  },
  {
    field: 'legal_name',
    label: 'DYNAMIC_FILTER.TRADING_NAME_KEY',
    defaultOperator: ConditionOperatorsEnum.ICONTAINS,
  },
  {
    field: 'zoho_id',
    label: 'DYNAMIC_FILTER.ZOHO_ID_KEY',
    defaultOperator: ConditionOperatorsEnum.ICONTAINS,
  },
  { field: 'company_uuid', label: 'DYNAMIC_FILTER.COMPANY_UUID_KEY' },
];
